import HeaderMenu from './Headers/HeaderMenu.js';
import '../styles/Menu.scss';
import FooterMenu from './Footers/FooterMenu.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import fish from '../images/fish.png';
import spaghetti from '../images/spaghetti.png';
import pizza from '../images/pizza.png';
import dish from '../images/dish.png';
import fries from '../images/fries.png';
import { faCartPlus, faShareNodes, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
function Menu() {
    return (
        <div className = "Menu">
            <HeaderMenu/>

                <div id = "menuHeaderImg">
                    <span>Menu</span>
                </div>

                <div id = "menuNavbar">
                    <ul>
                        <li><button tabIndex={0} id = "buttonAll">All</button></li>
                        <li><button tabIndex={0}>Breakfast</button></li>
                        <li><button tabIndex={0}>Lunch</button></li>
                        <li><button tabIndex={0}>Dinner</button></li>
                        <li><button tabIndex={0}>Drinks</button></li>
                        <li><button tabIndex={0}>Chef's Specials</button></li>
                        <li><button tabIndex={0}>More</button></li>
                    </ul>
                </div>

                <div id = "menuHeaderSpan">
                    <span>Explore Our Menu</span>
                    <p>Choose from a variety of fresh, delicious meals prepared with care and quality ingredients</p>
                </div>

                <div id = "menuItems">
                    <div className = "menuItems">
                        <img src = {fish}></img>
                        <span>Grilled Salmon Bowl</span>
                        <p>Fresh salmon served with greens, avocado <br></br> and light dressing</p>
                        <span>$18</span>
                        <button className = "addToCart">
                            <FontAwesomeIcon icon = {faCartPlus}/>
                        </button>
                        <button className = "shareDish">
                            <FontAwesomeIcon icon = {faShareNodes}/>
                        </button>
                    </div>

                    <div className = "menuItems">
                        <img src = {fries}></img> 
                        <span>Crispy Chicken & Fries</span>
                        <p>Golden fries with juicy chicken and <br></br> signature sauce</p>
                        <span>$14</span>
                        <button className = "addToCart">
                            <FontAwesomeIcon icon = {faCartPlus}/>
                        </button>
                        <button className = "shareDish">
                            <FontAwesomeIcon icon = {faShareNodes}/>
                        </button>
                    </div>

                    <div className = "menuItems">
                        <img src = {pizza}></img>
                        <span>Classic Margherita</span>
                        <p>Tomato sauce, fresh mozzarella and basil leaves</p>
                        <span>$12</span>
                        <button className = "addToCart">
                            <FontAwesomeIcon icon = {faCartPlus}/>
                        </button>
                        <button className = "shareDish">
                            <FontAwesomeIcon icon = {faShareNodes}/>
                        </button>
                    </div>

                    <div className = "menuItems">
                        <img src = {dish}></img>
                        <span>Chef’s Special Bowl</span>
                        <p>A perfect mix of seasonal ingredients<br></br> crafted by our chef</p>
                        <span>$16</span>
                        <button className = "addToCart">
                            <FontAwesomeIcon icon = {faCartPlus}/>
                        </button>
                        <button className = "shareDish">
                            <FontAwesomeIcon icon = {faShareNodes}/>
                        </button>
                    </div>

                    <div className = "menuItems">
                        <img src = {spaghetti}></img>
                        <span>Italian Spaghetti</span>
                        <p>Traditional pasta with rich tomato sauce<br></br> and parmesan</p>
                        <span>$13</span>
                        <button className = "addToCart">
                            <FontAwesomeIcon icon = {faCartPlus}/>
                        </button>
                        <button className = "shareDish">
                            <FontAwesomeIcon icon = {faShareNodes}/>
                        </button>
                    </div>

                    <div className = "menuItems">
                        <img src = {fish}></img>
                        <span>Beef Burger Deluxe</span>
                        <p>Juicy beef, cheddar cheese and fresh vegetables</p>
                        <span>$15</span>
                        <button className = "addToCart">
                            <FontAwesomeIcon icon = {faCartPlus}/>
                        </button>
                        <button className = "shareDish">
                            <FontAwesomeIcon icon = {faShareNodes}/>
                        </button>
                    </div>

                    <div className = "menuItems">
                        <img src = {pizza}></img>
                        <span>Vegan Power Bowl</span>
                        <p>Healthy mix of quinoa, veggies and <br></br> plant-based protein</p>
                        <span>$13</span>
                        <button className = "addToCart">
                            <FontAwesomeIcon icon = {faCartPlus}/>
                        </button>
                        <button className = "shareDish">
                            <FontAwesomeIcon icon = {faShareNodes}/>
                        </button>
                    </div>

                    <div className = "menuItems">
                        <img src = {fries}></img>
                        <span>Chicken Caesar Salad</span>
                        <p>Grilled chicken with fresh lettuce and <br></br> Caesar dressing</p>
                        <span>$11</span>
                        <button className = "addToCart">
                            <FontAwesomeIcon icon = {faCartPlus}/>
                        </button>
                        <button className = "shareDish">
                            <FontAwesomeIcon icon = {faShareNodes}/>
                        </button>
                    </div>

                    <div className = "menuItems">
                        <img src = {fries}></img>
                        <span>Spicy Mexican Wrap</span>
                        <p>Grilled chicken, veggies and spicy sauce <br></br>in a soft wrap</p>
                        <span>$12</span>
                        <button className = "addToCart">
                            <FontAwesomeIcon icon = {faCartPlus}/>
                        </button>
                        <button className = "shareDish">
                            <FontAwesomeIcon icon = {faShareNodes}/>
                        </button>
                    </div>

                    <div className = "menuItems">
                        <img src = {fries}></img>
                        <span>Crispy Chicken & Fries</span>
                        <p>Golden fries with juicy chicken and <br></br>signature sauce</p>
                        <span>$14</span>
                        <button className = "addToCart">
                            <FontAwesomeIcon icon = {faCartPlus}/>
                        </button>
                        <button className = "shareDish">
                            <FontAwesomeIcon icon = {faShareNodes}/>
                        </button>
                    </div>

                    <div className = "menuItems">
                        <img src = {pizza}></img>
                        <span>Classic Margherita</span>
                        <p>Tomato sauce, fresh mozzarella and basil leaves</p>
                        <span>$12</span>
                        <button className = "addToCart">
                            <FontAwesomeIcon icon = {faCartPlus}/>
                        </button>
                        <button className = "shareDish">
                            <FontAwesomeIcon icon = {faShareNodes}/>
                        </button>
                    </div>

                    <div className = "menuItems">
                        <img src = {pizza}></img>
                        <span>Spicy Mexican Wrap</span>
                        <p>Grilled chicken, veggies and spicy sauce in <br></br> a soft wrap</p>
                        <span>$12</span>
                        <button className = "addToCart">
                            <FontAwesomeIcon icon = {faCartPlus}/>
                        </button>
                        <button className = "shareDish">
                            <FontAwesomeIcon icon = {faShareNodes}/>
                        </button>
                    </div>
                </div>

                {/*<div id = "pageChooseCirclesMenu">

                    <div id = "leftArrow" className = "pageChooseCirclesMenu">
                        <FontAwesomeIcon icon = {faArrowLeft} id = "leftArrowIcon"/>
                    </div>

                    <div id = "one" className = "pageChooseCirclesMenu" tabIndex={0}>
                        <span>1</span>
                    </div>

                    <div id = "two" className = "pageChooseCirclesMenu" tabIndex={0}>
                        <span>2</span>
                    </div>

                    <div id = "three" className = "pageChooseCirclesMenu" tabIndex={0}>
                        <span>3</span>
                    </div>

                    <div id = "four" className = "pageChooseCirclesMenu" tabIndex={0}>
                        <span>4</span>
                    </div>

                    <div id = "five" className = "pageChooseCirclesMenu" tabIndex={0}>
                        <span>5</span>
                    </div>

                    <div id = "rightArrow" className = "pageChooseCirclesMenu">
                        <FontAwesomeIcon icon = {faArrowRight} id = "rightArrowIcon"/>
                    </div>
    </div>*/}
            <FooterMenu/>
        </div>
    )
}

export default Menu;